<app-header [pageTitle]="pageTitle" #appHeader (back)="goBack()"></app-header>
<ion-content>
  <div class="leave-syndicate">
    <h1 class="syndicate-name">{{ syndicate?.ps_name }}</h1>
    <p class="exit-description"> {{'leave-syndicate.Before' | translate}} <br />{{'leave-syndicate.understand' |
      translate}}</p>
    <h1 class="revert-decision" (click)="goBack()">{{'leave-syndicate.emoji' | translate}} </h1>
    <ion-row class="ion-no-padding first-row">
      <ion-col class="ion-no-padding" size="auto">
        <ion-card class="odd-card" (click)="leaveReason('dontUnderstand')">
          <h1 class="reason-emoji">🤔</h1>
          <p class="reason">{{'leave-syndicate.Don’t' | translate}} <br />{{'leave-syndicate.how' | translate}}</p>
        </ion-card>
      </ion-col>
      <ion-col class="ion-no-padding" size="auto">
        <ion-card class="even-card" (click)="leaveReason('dontWantToPlay')">
          <h1 class="reason-emoji">🗓️</h1>
          <p class="reason">
            {{'leave-syndicate.calender' | translate}}<br />
            {{'leave-syndicate.play' | translate}}
          </p>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-no-padding">
      <ion-col class="ion-no-padding" size="auto">
        <ion-card class="odd-card" (click)="leaveReason('tooExpensive')">
          <h1 class="reason-emoji">💸</h1>
          <p class="reason">{{'leave-syndicate.too' | translate}} <br />{{'leave-syndicate.expensive' | translate}}
          </p>
        </ion-card>
      </ion-col>
      <ion-col class="ion-no-padding" size="auto">
        <ion-card class="even-card" (click)="leaveReason('notWinning')">
          <h1 class="reason-emoji">😔</h1>
          <p class="reason">
            {{'leave-syndicate.not winning' | translate}} <br />
            {{'leave-syndicate.enough' | translate}}
          </p>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-no-padding last-row">
      <ion-col class="ion-no-padding" size="auto">
        <ion-card class="odd-card" (click)="leaveReason('wasNotAware')">
          <h1 class="reason-emoji">😧</h1>
          <p class="reason">
            {{'leave-syndicate.aware' | translate}} <br />
            {{'leave-syndicate.ongoing' | translate}}
          </p>
        </ion-card>
      </ion-col>
      <ion-col class="ion-no-padding" size="auto">
        <ion-card class="even-card" (click)="leaveReason('somethingElse')">
          <h1 class="reason-emoji">💬</h1>
          <p class="reason"> {{'leave-syndicate.Something' | translate}} </p>
        </ion-card>
      </ion-col>
    </ion-row>
  </div>
</ion-content>